import AboutHero from "../components/About/AboutHero";
import AboutIntro from "../components/About/AboutIntro";
import VisionMission from "../components/About/VisionMission";
import ValuesSection from "../components/About/ValuesSection";
import AboutStats from "../components/About/AboutStats";
import AboutCTA from "../components/About/AboutCTA";

export default function About() {
  return (
    <>
      <AboutHero />
      <AboutIntro />
      <VisionMission />
      <ValuesSection />
      <AboutStats />
      <AboutCTA />
    </>
  );
}